// extracted by mini-css-extract-plugin
export default {"title":"_53795d0b88","bld":"_456fb9f2c8"};